import React from "react";
import { AlertTriangleIcon, BrainIcon, DollarSignIcon, FrownIcon, HelpCircleIcon, ScanIcon, TimerIcon } from "lucide-react";
import { painPoints } from "../../data/content";
import { SectionCTA } from "../SectionCTA";
const iconMap = {
  frown: FrownIcon,
  timer: TimerIcon,
  scan: ScanIcon,
  help: HelpCircleIcon,
  dollar: DollarSignIcon,
  alert: AlertTriangleIcon,
  brain: BrainIcon
} as const;
export function PainPoints() {
  return <section className="bg-canvas px-4 py-16 md:py-24" data-id="element-246" data-mp="2hing6diu1igr">
      <div className="mx-auto max-w-3xl" data-id="element-247" data-mp="2cm6o588iijye">
        <h2 className="text-center font-serif text-[30px] font-extrabold leading-tight text-navy md:text-5xl" data-id="element-248" data-mp="2cnht3bdp1xr3">
          Do any of these sound <em className="italic text-brand" data-id="element-249" data-mp="2mjun6ad5idmd">familiar?</em>
        </h2>
        <p className="mt-4 text-center text-[17px] text-ink-muted md:text-lg" data-id="element-250" data-mp="2mhgpruv00pbn">
          If you answer <strong className="text-ink" data-id="element-251" data-mp="w984qh9gc909">YES</strong> to even one, I created this Playbook for you.
        </p>

        <ul className="mt-10 divide-y divide-navy/10 rounded-3xl bg-white px-5 shadow-sm md:px-8" data-id="element-252" data-mp="s7wmiwswqq23">
          {painPoints.map(p => {
          const Icon = iconMap[p.icon as keyof typeof iconMap];
          return <li key={p.text} className="flex gap-4 py-5" data-id="element-253" data-mp="1x69am4w3sgj0">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gold-light" data-id="element-254" data-mp="1x3wmtb3nzby1">
                  <Icon className="h-5 w-5 text-navy" aria-hidden="true" data-id="element-255" data-mp="21yj1po8yfmmv" />
                </span>
                <p className="text-[16px] leading-snug text-ink md:text-lg" data-id="element-256" data-mp="26y5btothkmrg">{p.text}</p>
              </li>;
        })}
        </ul>

        <div className="mt-12 text-center" data-id="element-257" data-mp="2fw7hwis2u5ll">
          <p className="font-serif text-2xl font-extrabold text-navy md:text-3xl" data-id="element-258" data-mp="2fueav2djxjd2">And it shouldn't have to feel this complicated.</p>
          <div className="mx-auto mt-5 max-w-2xl space-y-4 text-[17px] leading-relaxed text-ink-muted" data-id="element-259" data-mp="lipx33j23mu9">
            <p data-id="element-260" data-mp="qh15d9tpdpad">The problem isn't necessarily that you need another 50-hour course. In my experience, one of the biggest problems is that dentists are given information <strong className="text-ink" data-id="element-261" data-mp="iixryxogb8vn">without a practical decision sequence.</strong></p>
            <p data-id="element-262" data-mp="eh2slyq2z5ki">You don't need another pile of notes. You need a system that helps you organize what you already know and identify what needs to be evaluated before you move forward.</p>
          </div>
        </div>

        <SectionCTA label="Get the Implant Planning System" data-id="element-263" data-mp="ni0vgdos971i" />
      </div>
    </section>;
}